import api from "../../../../../api/client";
import { AUCTION } from "../../../../../api/endpoints";
import { handleApiError, handleApiResponse } from "../../../../../api/handlers";


export async function getAuctionOverview(auctionId) {
  try {
    const response = await api.get(AUCTION.AI_OVERVIEW(auctionId));
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}